import React, { useState } from "react";

// Components
import { Button, Columns, Form, Tag } from 'react-bulma-components';
import { Thumbnail } from "shared/components/user";
import { Edit3, X } from 'react-feather';

// utils
import { getUserInitials } from "shared/utils";

// Styles
import styles from './UserDetail.module.scss';

const UserDetail = ({ role='', user='', onSave }) => {
    const { Input, InputFile, Field, Control, Label } = Form;
    const { name, surname, image, phone, email, city, country, zip } = user;
    const initials = getUserInitials(name, surname);

    const initialUser = {
        name: name !== null ? name : '',
        surname: surname !== null ? surname : '',
        image: image !== null ? image : '',
        phone: phone !== null ? phone : '',
        email: email !== null ? email : '',
        city: city !== null ? city : '',
        country: country !== null ? country : '',
        zip: zip !== null ? zip : '',
        //password: null,
        //password_confirmation: null,
    }

    const [updatedUser, setUpdatedUser] = useState(initialUser);
    const [showUpload, setShowUpload] = useState(false);
    const [uploadedPhoto, setUploadedPhoto] = useState('');

    const handleUploadPhoto = (e) => {
        if (e.target.files.length > 0) {
            setUploadedPhoto(e.target.files[0]);
        }
    }

    const handleInputChange = (e) => {
        setUpdatedUser(prevState => ({
           ...prevState,
           [e.target.name]: e.target.value
        }));
    }


    const handleSaveUser = (e) => {
        e.preventDefault();

        // Sending all the form data
        const bodyFormData = new FormData(e.target);

        // parent component handles update
        onSave(bodyFormData);
    }

    const handleClickEdit = (e) => {
        e.preventDefault();
        setShowUpload(!showUpload);
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setUpdatedUser(initialUser);
        setUploadedPhoto('');
        setShowUpload(false);
    }

    if(!user) {
        return <p>Loading...</p>
    }

    return (
        <article className={ styles.detail }>
            <form onSubmit={ handleSaveUser }>
                <header className={ styles.header }>
                    <div className={ styles.image }>
                        <Thumbnail
                            size="large"
                            image={ updatedUser.image }
                            initials={ initials }
                            backgroundColor="rgb(0, 48, 80)" />

                        <Button
                            className={ `${styles.edit} ${ showUpload ? styles.active : '' }` }
                            color="ghost"
                            onClick={ handleClickEdit }
                            rounded>
                            { showUpload ? <X size={18} /> : <Edit3 size={18} />}
                        </Button>
                    </div>
                    <div className={ styles.upload }>
                    { showUpload &&
                        <Field>
                            <Control>
                                <InputFile
                                    name="image"
                                    label="Upload a photo"
                                    onChange={ handleUploadPhoto }
                                />
                                <span className="file-name">
                                 { uploadedPhoto && uploadedPhoto.name }
                                </span>
                            </Control>
                        </Field>
                    }
                    </div>
                </header>
                <Columns>
                    <Columns.Column>
                        <Field>
                            <Label>Name</Label>
                            <Control>
                                <Input
                                    name="name"
                                    onChange={ handleInputChange }
                                    required
                                    value={ updatedUser.name }
                                />
                            </Control>
                        </Field>
                        <Field>
                            <Label>Last Name</Label>
                            <Control>
                                <Input
                                    onChange={ handleInputChange }
                                    name="surname"
                                    required
                                    value={ updatedUser.surname }
                                />
                            </Control>
                        </Field>
                        <Field>
                            <Label>Email</Label>
                            <Control>
                                <Input
                                    onChange={ handleInputChange }
                                    name="email"
                                    required
                                    value={ updatedUser.email }
                                    />
                            </Control>
                        </Field>
                        <Field>
                            <Label>Phone</Label>
                            <Control>
                                <Input
                                    onChange={ handleInputChange }
                                    name="phone"
                                    required
                                    value={ updatedUser.phone }
                                    />
                            </Control>
                        </Field>
                        { /*
                        <Field>
                            <Label>New Password</Label>
                            <Control>
                                <Input
                                    name="password"
                                    onChange={ handleInputChange }
                                    type="password"
                                    value={ updatedUser.password === null ? '' : updatedUser.password }
                                />
                            </Control>
                        </Field>
                        <Field>
                            <Label>Confirm New Password</Label>
                            <Control>
                                <Input
                                    name="password_confirmation"
                                    onChange={ handleInputChange }
                                    type="password"
                                    value={ updatedUser.password_confirmation === null ? '' : updatedUser.password_confirmation  }
                                />
                            </Control>
                        </Field>
                        */}
                    </Columns.Column>

                    <Columns.Column>
                        <Field>
                            <Label>City</Label>
                            <Control>
                                <Input
                                    name="city"
                                    id="city"
                                    onChange={ handleInputChange }
                                    type="text"
                                    value={ updatedUser.city ? updatedUser.city : '' }
                                    />
                            </Control>
                        </Field>
                        <Field>
                            <Label>Zip code</Label>
                            <Control>
                                <Input
                                    name="zip"
                                    id="zip"
                                    onChange={ handleInputChange }
                                    type="text"
                                    value={ updatedUser.zip ? updatedUser.zip : '' }
                                    />
                            </Control>
                        </Field>
                        <Field>
                            <Label>Country</Label>
                            <Control>
                                <Input
                                    name="country"
                                    id="country"
                                    onChange={ handleInputChange }
                                    type="text"
                                    value={ updatedUser.country ? updatedUser.country : '' }
                                    />
                            </Control>
                        </Field>
                    </Columns.Column>

                </Columns>
                <div className={ styles.actions }>
                     <Button.Group>
                         <Button onClick={ handleCancel }>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            className={ styles.secondary }>
                            Save Changes
                        </Button>
                     </Button.Group>
                </div>
            </form>
        </article>
    )
}

export default React.memo(UserDetail);
